const STORAGE_KEY = 'regenloop-theme';
const LEGACY_STORAGE_KEY = 'lineageatlas-theme';
const DEFAULT_THEME = 'dark';
function readStoredTheme() {
    if (typeof window === 'undefined')
        return null;
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark')
        return stored;
    const legacyStored = localStorage.getItem(LEGACY_STORAGE_KEY);
    if (legacyStored === 'light' || legacyStored === 'dark') {
        localStorage.setItem(STORAGE_KEY, legacyStored);
        return legacyStored;
    }
    return null;
}
export function hasStoredThemePreference() {
    return readStoredTheme() !== null;
}
export function getTheme(defaultTheme = DEFAULT_THEME) {
    return readStoredTheme() ?? defaultTheme;
}
export function applyThemeDefault(defaultTheme = DEFAULT_THEME) {
    const theme = getTheme(defaultTheme);
    if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('data-theme', theme);
    }
    return theme;
}
export function setTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);
}
export function toggleTheme(defaultTheme = DEFAULT_THEME) {
    const next = getTheme(defaultTheme) === 'dark' ? 'light' : 'dark';
    setTheme(next);
    return next;
}
export function initTheme(defaultTheme = DEFAULT_THEME) {
    applyThemeDefault(defaultTheme);
    window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', () => {
        if (!hasStoredThemePreference()) {
            applyThemeDefault(defaultTheme);
        }
    });
}
//# sourceMappingURL=theme.js.map